import { Box } from 'components/Material/Box'
import { Image } from 'components/Custom/Image'
import error_icon from 'assets/images/error_404.png'
import { Link } from 'components/Material/Link'

interface ErrorPageComponentProps {
  refetchpage?: () => void
  message?: string
  showIcon?: boolean
}

const ErrorPageComponent = ({
  refetchpage,
  message = 'Alguma coisa deu errado, clique aqui para recarregar a página',
  showIcon = true
}: ErrorPageComponentProps) => {
  const handleClick = () => {
    if (refetchpage) {
      refetchpage()
    } else {
      window.location.reload()
    }
  }

  return (
    <Box className="w-full h-full flex flex-col items-center justify-center pb-20 gap-4">
      {showIcon && (
        <Image
          className="mt-5 lg:mt-0 w-[128px] lg:w-[230px] lg:h-[180px]"
          src={error_icon}
          alt="Ícone de erro"
        />
      )}
      <Link
        title={message}
        className="hover:bg-slate-200 no-underline p-2 text-center rounded-md transition-colors cursor-pointer"
        onClick={handleClick}
      >
        {message}
      </Link>
    </Box>
  )
}

export default ErrorPageComponent
